export const environment = {
  production: true,
  staging: false,
  realm: 'iggoe',
  issuer: 'https://auth.iggoe.at',
  hasuraUrl: 'https://hasura.iggoe.at/v1/graphql',
  hasuraWsUrl: 'wss://hasura.iggoe.at/v1/graphql',
  externalServiceUrl: 'https://external.iggoe.at/api',
  tileUrl: 'https://tiles.iggoe.at',
  rum: {
    enabled: true,
    clientToken: 'rumjeViFaRaKR6U6q7Y',
    site: 'openobserve.iggoe.at',
    organizationIdentifier: 'default',
    env: 'production'
  }
};
